import React from "react";

export default function PriseServiceTransdev() {
  return <div style={{ marginTop: "40px" }}>Prise de service - Transdev</div>;
}
